/*
 *  Copyright (C) GridGain Systems. All Rights Reserved.
 *  _________        _____ __________________        _____
 *  __  ____/___________(_)______  /__  ____/______ ____(_)_______
 *  _  / __  __  ___/__  / _  __  / _  / __  _  __ `/__  / __  __ \
 *  / /_/ /  _  /    _  /  / /_/ /  / /_/ /  / /_/ / _  /  _  / / /
 *  \____/   /_/     /_/   \_,__/   \____/   \__,_/  /_/   /_/ /_/
 */

import { Injectable, inject } from '@angular/core';
import { extractError } from '@app/common/utils';
import { Actions, createEffect } from '@ngrx/effects';
import { filter, map, tap } from 'rxjs';
import { ErrorSinkService } from '../services/error-sink.service';
import { GmcNotificationService } from '../services/gmc-notification.service';
import { error as errorAction, stompError } from './actions';

@Injectable()
export class NotificationEffects {
  private actions$ = inject(Actions);
  private errorSinc: ErrorSinkService = inject(ErrorSinkService);
  private gmcNotification = inject(GmcNotificationService);

  error$ = createEffect(() =>
    this.errorSinc.subscribe().pipe(
      filter((error) => error.source === 'effect'),
      map((error) => errorAction({ text: error.error })),
    ),
  );

  stompError$ = createEffect(() =>
    this.errorSinc.subscribe().pipe(
      filter((error) => error.source === 'STOMP'),
      map((error) =>
        stompError({
          error: extractError(error.error, `Websocket Failure`),
          silent: error.silent,
        }),
      ),
    ),
  );

  showNotification$ = createEffect(
    () =>
      this.actions$.pipe(
        tap((action) => {
          if (action.notification) this.gmcNotification.notify(action.notification);
        }),
      ),
    { dispatch: false },
  );
}
